import React, { useEffect, useRef, useState } from "react";

const CodeEditorMock = ({ children }) => {
  const codeRef = useRef(null);
  const [lineCount, setLineCount] = useState(1);

  useEffect(() => {
    const el = codeRef.current;

    const calculateLines = () => {
      if (el) {
        // Satır yüksekliğini aynı alıyoruz (px cinsinden)
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        const height = el.offsetHeight;
        const lines = Math.round(height / lineHeight);
        setLineCount(lines);
      }
    };

    calculateLines();

    const resizeObserver = new ResizeObserver(calculateLines);
    if (el) resizeObserver.observe(el);

    return () => {
      resizeObserver.disconnect();
    };
  }, [children]);

  return (
    <div style={{ display: "flex", fontFamily: "monospace" }}>
      {/* Satır numaraları */}
      <div
        style={{
          textAlign: "right",
          marginRight: "25px",
          color: "white",
          opacity: 0.5,
          userSelect: "none",
          lineHeight: "25px", // Satır numaralarının line-height'i
          minWidth: "30px", // biraz genişlik verelim
        }}
      >
        {Array.from({ length: lineCount }, (_, i) => (
          <div key={i}>{i + 1}</div>
        ))}
      </div>

      {/* Kod içeriği */}
      <div
        ref={codeRef}
        style={{
          color: "white",
          opacity: 0.8,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          lineHeight: "25px", // Kod satırlarının line-height'i, numaralarla aynı
          maxWidth: "600px",
          flex: 1,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default CodeEditorMock;
